import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { AccountSelectionService, AuthService } from "@front/m19-services";
import { DebugInfoModalComponent, DebugPayloadInput, ModalOptions } from "@front/m19-ui";
import { environment } from "../../../environments/environment";
import { BoardType, LayoutSelectorService } from "@m19-board/layout-selector.service";

@Component({
  selector: "app-board-debug-info-modal",
  template: `<IDebugInfoModal [debugPayloadInput]="debugPayloadInput()" [githubIssueLabels]="['bug']" />`,
  imports: [DebugInfoModalComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoardDebugInfoModalComponent {
  static readonly defaultModalOptions: Omit<ModalOptions<unknown>, "data"> = { size: "md" };

  private accountService = inject(AccountSelectionService);
  private layoutSelectionService = inject(LayoutSelectorService);
  private authService = inject(AuthService);

  private accountMarketplaces = toSignal(this.accountService.accountMarketplacesSelection$);

  debugPayloadInput = computed<DebugPayloadInput>(() => ({
    boardVersion: environment.commit_hash,
    boardBuildTimestamp: environment.build_timestamp,
    accountMarketplaces: this.accountMarketplaces() ?? [],
    useBoardAdminPrefix: this.layoutSelectionService.getBoardType() == BoardType.M19 || this.authService.isAdminLogin(),
  }));
}
